import {TypeTableCar1} from './TypeTableCar1';
import {TypeTableauLibre} from './TypeTableauLibre';
import {TypeTableMinMax} from './TypeTableMinMax';
import {TypeOuiNon} from './TypeOuiNon';
export class TypeCaracteristiquesMAPA {

	public tabCarLibre: TypeTableauLibre;

	public tabCarMinMax: TypeTableMinMax;

	public variantes: TypeOuiNon;

	public quantites: string;

	public tabCar1: TypeTableCar1;

	public principales: string;

	constructor() { 
		 		this.tabCarLibre = new TypeTableauLibre();
		this.tabCarMinMax = new TypeTableMinMax();
		this.variantes = new TypeOuiNon();
		this.quantites = '';
		this.tabCar1 = new TypeTableCar1();
		this.principales = '';
 
	}
}
